var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRepeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5455 5.42394C13.772 5.26596 14.0836 5.32149 14.2416 5.54797C14.8255 6.38505 15.168 7.40367 15.168 8.50069C15.168 11.3542 12.8548 13.6674 10.0013 13.6674H5.04902L5.98809 14.4499C6.20023 14.6267 6.22889 14.942 6.0521 15.1541C5.87532 15.3663 5.56004 15.3949 5.3479 15.2181L3.3479 13.5515C3.18618 13.4167 3.1262 13.1951 3.19786 12.9971C3.26952 12.7992 3.45748 12.6674 3.66799 12.6674H10.0013C12.3025 12.6674 14.168 10.8019 14.168 8.50069C14.168 7.61479 13.8921 6.79477 13.4214 6.12008C13.2635 5.8936 13.319 5.58192 13.5455 5.42394Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.94792 1.84594C10.1247 1.6338 10.44 1.60514 10.6521 1.78192L12.6521 3.44858C12.8138 3.58335 12.8738 3.80497 12.8022 4.00291C12.7305 4.20084 12.5425 4.33269 12.332 4.33269H5.9987C3.69751 4.33269 1.83203 6.19818 1.83203 8.49936C1.83203 9.38527 2.10796 10.2053 2.57858 10.88C2.73656 11.1065 2.68103 11.4181 2.45455 11.5761C2.22806 11.7341 1.91639 11.6786 1.7584 11.4521C1.17451 10.615 0.832031 9.59639 0.832031 8.49936C0.832031 5.64589 3.14523 3.33269 5.9987 3.33269H10.951L10.0119 2.55014C9.7998 2.37336 9.77114 2.05807 9.94792 1.84594Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRepeat);
export default __webpack_public_path__ + "static/media/ic-repeat.4b968e0a24b2648715f01cebdb451033.svg";
export { ForwardRef as ReactComponent };